import { render, staticRenderFns } from "./BaseDrinkInfo.vue?vue&type=template&id=10c94cb1&scoped=true&"
import script from "./BaseDrinkInfo.vue?vue&type=script&lang=ts&"
export * from "./BaseDrinkInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c94cb1",
  null
  
)

export default component.exports